import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import { ControlledMuiAutoCompleteSelect, ControlledTextField, IOptionType, PillButton } from '@zz2/zz2-ui';
import { useForm } from 'react-hook-form';
import FreshServiceTicketModelHelper from '../../@types/model/freshService/freshServiceTicketModelHelper';
import { IFreshServiceTicketFormValues } from '../../@types/model/freshService/freshServiceTicketFormValues';
import CustomReactHookFormDevTools from '../customComponents/devTools/ReactHookFormDevTools';

interface IFreshServiceTicketFormProps {
    initialValues : IFreshServiceTicketFormValues;
    isLoading : boolean;
    onSubmit : (values : IFreshServiceTicketFormValues) => void;
    onCancel : () => void;

    userOptions : Array<IOptionType>;
}

const FreshServiceTicketForm = (props : IFreshServiceTicketFormProps) : React.ReactElement => {
    const schema = FreshServiceTicketModelHelper.formSchema();

    /*================================================================================================================
     *                                                  Form
     * ==============================================================================================================*/

    const { handleSubmit, control, formState: { isValid } } = useForm<IFreshServiceTicketFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(schema),
        mode: 'onChange'
    });

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30 pt15 pb0'}>
                    <div className={'fdc wfill pt10 jcc aic'}>
                        <ControlledTextField
                            name={'systemName'}
                            label={'System Name'}
                            className={'wfill mb10'}
                            size={'small'}
                            control={control}
                            disabled={true}
                        />
                        <div className='h10' />
                        <ControlledTextField
                            name={'systemVersion'}
                            label={'System Version'}
                            className={'wfill mb10'}
                            size={'small'}
                            control={control}
                            disabled={true}
                        />
                        <div className='h10' />
                        <ControlledTextField
                            name={'location'}
                            label={'Location'}
                            className={'wfill mb10'}
                            size={'small'}
                            control={control}
                            disabled={true}
                        />
                        <div className='h10' />
                        <ControlledTextField
                            name={'name'}
                            label={'Name'}
                            className={'wfill mb10'}
                            size={'small'}
                            control={control}
                            disabled={true}
                        />
                        <div className='h10' />
                        <ControlledTextField
                            name={'email'}
                            label={'Email'}
                            className={'wfill mb10'}
                            size={'small'}
                            control={control}
                            disabled={true}
                        />
                        <div className='h10' />
                        <ControlledTextField
                            name={'description'}
                            label={'Description'}
                            className={'wfill mb10 ml10'}
                            multiline={true}
                            rows={4}
                            variant={'standard'}
                            size={'small'}
                            control={control}
                        />
                        <div className='h10' />
                        <ControlledMuiAutoCompleteSelect 
                            name='referencedUser'
                            control={control}
                            label={'Manager'} 
                            className={'wfill mb10'}
                            defaultValues={props.initialValues.referencedUser ?? null}
                            options={props.userOptions}
                        />
                    </div>
                    <div className='h20' />
                    <div className={'fdr flx1 aic jcfe mb20'}>
                        <Button
                            className={'cpd mr20'}
                            onClick={props.onCancel}
                            type={'reset'}
                            disabled={props.isLoading}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={!isValid || props.isLoading}
                        />
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </>
    );
};

export default FreshServiceTicketForm;
